<template>
  <div class="addOne" >
      <header>
          <div class="headerOne" >
             <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
              <!-- <img src="../../assets/images/returnOne.png" @click="$router.go(-1)">   -->
          </div>
       
            <span class="myOne">交易明细</span>
            <!-- 点击显示 或者隐藏 -->
            <img src="../../assets/images/choose.png"  class="choose" @click="recordAdd">
            <div class="all">       
                <ul class="triangle" v-if="recordOne">
                    <li></li>
                    <li @click="rechargeRecord(0)">全部记录</li>
                    <li @click="rechargeRecord(1)">成功充值</li>
                    <li @click="rechargeRecord(2)">消费</li>
                    <!-- <li @click="refund(2)">已退款</li> -->
                </ul> 
            </div>
    </header>
       <div class="zhanwei"></div>
    <div class="integral">
        <p>我的该卡余额(元)</p>
        <span class="thitOne">{{balance}}</span>   
    </div>

    <div class="record">
                  <ul v-if="haveRecord">
                      <!-- 写一个flag控制事件的移除 -->
                      <li v-for="(item,index) in filterCardList(this.type)" :key="index" @click="flag && goHistory(item.orderType,item.orderStatus,item.orderId,item.payBackStatus)" class="isCard">
                          <div class="oneRecord">
                               <!-- 订单实付金额  -->
                              <span v-if="item.orderType==2?true:false">{{item.moneyReal}}</span>
                               <!-- 充值金额 -->
                              <span  v-if="item.orderType==1?true:false">{{item.moneyReal}}</span>
                               <span v-if="item.orderType==1?true:false">充值</span>
                               <span v-if="item.orderType==2?true:false">消费</span>
                          </div>
                          <div class="twoRecord">
                            <span>{{item.orderTime}}</span>
                            <!-- 占时不写 -->
                            <!-- <span v-if="item.payBackStatus==0 && item.orderType==2?true:false">未退款</span> -->
                            <span v-if="item.payBackStatus==1 && item.orderType==2 && item.orderStatus==1?true:false" class="refundSuccess">退款成功</span>
                            <span v-if="item.orderStatus==0 && item.orderType==2 && item.payBackStatus==0?true:false" class="refundSuccess">待支付</span>
                            <span v-if="item.orderStatus==1 && item.orderType==2 && item.payBackStatus==0?true:false" >支付成功</span>
                            <span v-if="item.orderStatus==1 && item.orderType==1 ?true:false">充值成功</span>
                          </div> 
                      </li>
                  </ul>
              <div v-if="!haveRecord" class="onlyDiv">暂无交易记录</div>
      </div>
  </div>
</template>
<script>
import axios from "axios";
import show from "@/assets/js/show.js";
import { Popup ,Toast } from 'mint-ui';

export default {
  data() {
    return {
      isType: false,
      flag: true,
      recordOne: false,
      balance: this.$route.query.rmbNum,
      orderStatus: "", //订单状态
      orderType: "", //订单类型
      orderTime: "", //订单时间
      cardList: [], //所有的交易信息
      date: "",
      unbind: false,
      type: 0,
      cTypeIdFive: "",
      haveRecord:true,
      success:1,
      Toast: Toast({
          message: '加载中...',
          position: 'middle',
          duration: -1
        }),
    };
  },
  computed: {
    wsWbsocket() {
      return this.$store.state.wsWbsocket;
    }
  },
  methods: {
    checkHttpReturn(id)
    {
                if(httpSendQue[id]==0)
                {
                    var  self=this;
                    setTimeout(() => {
                            if (self && !self._isDestroyed)
                                self.checkHttpTimeOut();
                        }, newConfigTime);

                }
                else
                {
                    delete httpSendQue[id];
                }
            },
    checkHttpTimeOut()
    {
        if(httpSendQue[id]==0)
        {
            //  隐藏加载中
              this.Toast.close()
              Toast({
                    message: '网络不给力',
                    position: 'middle',
                    duration: 3000
                  })
              

        }
        else
        {
            //删除数组中的id
            delete httpSendQue[id];

        }
    },
    // 获取交易信息 
    websocketOne() {
        var sidTwo = this.$route.query.sidTwo;
        var cidTwo = this.$route.query.cidTwo;
        var  self=this;     
        id= getHttpSendId ();
        getArry(id)   //将生成ID放入数组  
        setTimeout(() => 
        {
            if (self && !self._isDestroyed)
                self.checkHttpReturn(id);
        }, configTime);      
        axios.get(transactionRecord+"&uid="+uid+"&sign="+sign+"&mode="+mode+"&sid="+sidTwo+"&cid="+cidTwo+"&orderBy="+0+"&beginIdx="+0+"&maxRows="+50)
            .then(res=>{  
                      httpSendQue[id] = 1; 
                      this.Toast.close();
                      if(res.data.s==0){
                            this.haveRecord=true  
                            this.cardList = res.data.list;
                            this.$store.commit("cardList",res.data.list)
                      }
                      else if(res.data.s==1010)
                      {
                            this.haveRecord=false  
                      }
                  })
            .catch(error=>{
                      this.Toast.close()
                              Toast({
                                    message: '网络不给力',
                                    position: 'middle',
                                    duration:2000
                                  })            
                        })
    
  
    },
    // 充值记录
    filterCardList(val) {
      if (val == 0) {
        return this.cardList;
      }
      return this.cardList.filter(function(item) {
        return item.orderType == val;
      });
       return this.cardList.filter(function(item) {
        return item.payBackStatus == val;
      });
    },
    rechargeRecord(orderType) {
      this.type = orderType;
   
    },
    refund(payBackStatus){
          this.type = payBackStatus;
    },
    // 消费记录
    expenseCalendar() {
      // alert("消费");
    },
    // fixOne 订单类型  fixTwo
    goHistory(fixOne, fixTwo, orderIdOne,orderId) {
      var  sid=this.$route.query.sidTwo
      var  cid=this.$route.query.cidTwo 
      this.$router.push({
        name:"history",
        query:{
            orderType:  fixOne,
            orderStatus:fixTwo,
            orderId:orderIdOne,
            payBackStatus:orderId,
            sid:sid,
            cid:cid
        }
      })
    },
    // 点击显示或者隐藏事件
    recordAdd() {
      if (this.recordOne == false) {
        this.recordOne = true;
        this.flag = false;
      } else {
        this.recordOne = false;
        this.flag = true;
      }
     
    }
    
  },
  created() {
       
          
  },
  mounted(){
        this.websocketOne();
  },
  destroyed()
    {
    this.Toast.close()
   
    }
};
</script>
<style scoped>
.zhanwei{
   height: 1.6rem;
  width: 100%;
 background: white
}
.refundSuccess{
  color: red !important
}
.onlyDiv{
  border: none;
  color: rgba(0, 0, 0, .8);
  font-size: 0.55rem;
  text-align: center;
  margin-top: 5rem

}
.el-icon-arrow-left{
    font-size: 0.7rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
header {
  height: 1.6rem;
  width: 100%;
  position: fixed;
  top: 0;
  background: white;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.headerOne {
  font-size: 0;
  width: 20%;
      
}
.headerOne img {
  display: inline-block;
  margin-top: 0.3rem;
}
.headerOne img:nth-child(1) {
  margin-left: 0.2rem;
}
.myOne {
  font-size: 0.55rem;
  position: absolute;
  top: 0.42rem;
  left: 4rem;
}
.choose {
  width: 0.8rem;
  height: auto;
  position: absolute;
  right: 0.4rem;
  top: 0.65rem;
}
.integral {
  width: 100%;
  height:4rem;
  background: gray;
  background-image: url("../../assets/images/bgOne.png");
  background-repeat: no-repeat;
  background-size: 100% 4rem;
}
.integral p {
  font-size: 0.55rem;
  color: white;
  padding: 0.2rem 0 0 0.3rem;
}
.integral span.thitOne {
  color: white;
  font-size: 0.75rem;
  text-align: center;
  display: block;
  padding: 0.75rem 0.3rem 0.15rem 0;
}
.integral span.befor {
  font-size: 0.45rem;
  text-align: center;
  display: block;
  color: white;
}
.record {
  width: 90%;
  margin: 0 auto;
}
.record ul li {
  height: 1.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.record ul li span {
  font-size: 0.45rem;
}
.record ul li .oneRecord {
  clear: both;
  margin-top: 0.4rem;
}
.record ul li .twoRecord {
  clear: both;
  height: 0.5rem;
  padding-top: 0;
}
.record ul li .oneRecord span:nth-child(1) {
  font-size:  0.5rem;
  float: left;
}
.record ul li .oneRecord span:nth-child(2) {
  font-size:  0.5rem;
  float: right;
}
.record ul li .twoRecord span:nth-child(1) {
  font-size: 0.5rem;
  float: left;
  color: rgba(0, 0, 0, 0.2);
  padding-top: 0.08rem;
}
.record ul li .twoRecord span:nth-child(2) {
  font-size: 0.5rem;
  float: right;
  color: #2ea4b0;
}
.all {
  position: relative;
}
.all .triangle {
  color: #333333;
  font-size: 0.55rem;
  background: #fafafa;
  width:3.7rem;

  position: relative;
  left: 6rem;
  top: 0rem;
  border-radius:0.1rem;
  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.2);
}
.all .triangle li {
  line-height:1.2rem;
  text-align: center;
  /* width: 1rem */
}
.all .triangle li:nth-child(1) {
  width: 0;
  height: 0;
  border-left: 0.13rem solid transparent;
  border-right: 0.13rem solid transparent;
  border-bottom: 0.15rem solid #fafafa;
  position: absolute;
  top: -0.14rem;
  left: 3.1rem;
}
.all .triangle li:nth-child(2),
.all .triangle li:nth-child(3),
.all .triangle li:nth-child(4) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/deal/deal.vue